import { render } from "./RegisterAccount.vue?vue&type=template&id=6b68142a&scoped=true"
import script from "./RegisterAccount.vue?vue&type=script&lang=js"
export * from "./RegisterAccount.vue?vue&type=script&lang=js"

import "./RegisterAccount.vue?vue&type=style&index=0&id=6b68142a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b68142a"]])

export default __exports__